import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid } from "semantic-ui-react";
import format from "date-fns/format";
import addSeconds from "date-fns/addSeconds";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { openModal } from "../../../app/common/modals/modalReducer";
// import SmartDataTable from "react-smart-data-table";
// import { getAssignedLeads /*getConsultantUser, getcurrentUserProfileUser*/ } from "../leadActions";
import { getAssignedLeads, setFilterStatus /*getConsultantUser, getcurrentUserProfileUser*/ } from "../leadActions";
import { Formik } from "formik";
import MySelectInput from "../../../app/common/form/MySelectInput";
import MyTextInput from "../../../app/common/form/MyTextInput";
import { useTable, useGlobalFilter, useAsyncDebounce } from "react-table";

import firebase from "../../../app/config/firebase";
import { subDays, subMonths } from "date-fns";
const firestore = firebase.firestore();
const LOG_URL = "https://mytiny.inspireonline.co.za/api/v1/log.php";

async function sendPerfLog(payload) {
    try {
        await fetch(LOG_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-TEST-KEY": "temp123"
            },
            body: JSON.stringify(payload),
        });
    } catch (error) {
        console.log("[perf] log failed", error?.message || error);
    }
}

// Define a default UI for filtering
function GlobalFilter({ preGlobalFilteredRows, globalFilter, setGlobalFilter }) {
    const count = preGlobalFilteredRows.length;
    const [value, setValue] = useState(globalFilter);
    const onChange = useAsyncDebounce((value) => {
        setGlobalFilter(value || undefined);
    }, 1000);

    return (
        <div className="ui icon input" style={{ marginTop: -10 }}>
            <input
                type="text"
                name="filterValue"
                id="filterValue"
                value={value || ""}
                placeholder={`Filter ${count} results`}
                onChange={(e) => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }}
            />
            <i className="search icon" />
        </div>
    );
}

export default function LeadsDashboardPage(props) {
    const dispatch = useDispatch();
    const [usersFilterList, setUsersFilterList] = useState([]);
    const [filterValue, setFilterValue] = useState("");
    const [leads, setLeads] = useState([]);
    const [loadingLeads, setLoadingLeads] = useState([]);
    const [filterUser, setFilterUser] = useState("");
    // const [filterStatus, setFilterStatus] = useState("");
    const filterStatus = useSelector((state) => state.lead.filterStatus);
    const [filterEmail, setFilterEmail] = useState("");
    const [showSearchError, setShowSearchError] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [moreDisabled, setMoreDisabled] = useState(false);
    const initialLoadLoggedRef = useRef(false);
    const initialLoadRef = useRef(false);
    const [historyMonths, setHistoryMonths] = useState(12);

    const { currentUserProfile } = useSelector((state) => state.profile);

    const historyMonthOptions = [
        { key: "30days", text: "Last 30 days", value: "30days" },
        { key: 6, text: "Last 6 months", value: 6 },
        { key: 12, text: "Last 12 months", value: 12 },
        { key: 18, text: "Last 18 months", value: 18 },
        { key: 24, text: "Last 24 months", value: 24 },
        { key: "All", text: "All time", value: "All" },
    ];

    const getNetworkInfo = () => {
        if (typeof navigator === "undefined") return {};
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (!connection) return {};
        return {
            effectiveType: connection.effectiveType,
            downlink: connection.downlink,
            rtt: connection.rtt,
            saveData: connection.saveData,
        };
    };

    // useEffect(() => {
    // if (currentUserProfile?.id) {
    //     alert(currentUserProfile.id);
    // }
    // }, [currentUserProfile]);



    useEffect(() => {
        if (!currentUserProfile?.id) return;

        const normalizeStatus = (value) => (value && value !== "" ? value : "Assigned");
        const normalizeHistory = (value) => {
            if (value === undefined || value === null || value === "") return 12;
            if (value === "All" || value === "all" || value === 0 || value === "0") return "All";
            if (value === "30days") return "30days";
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) ? 12 : parsed;
        };

        const statusValue = normalizeStatus(currentUserProfile?.leadStatusOrder);
        const historyValue = normalizeHistory(currentUserProfile?.noLeadsLoad);

        updateUser(currentUserProfile?.id);
        updateStatus(statusValue);
        setHistoryMonths(historyValue);

        if (initialLoadRef.current) return;
        initialLoadRef.current = true;

        changeConsultant(
            { value: currentUserProfile?.id },
            { value: statusValue },
            "",
            { value: historyValue }
        );
    }, [currentUserProfile?.id, currentUserProfile?.leadStatusOrder, currentUserProfile?.noLeadsLoad]);

    useEffect(() => {
        const unsubscribe2 = firestore
            .collection("users")
            .where("isConsultant", "==", true)
            .onSnapshot((snapshot) => {
                let list = [];

                snapshot.docs.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), ["id"]: `${doc.id}` };
                        list.push(appObj);
                    }
                });
                const externalConsultants = firestore
                    .collection("users")
                    .where("isExternal", "==", true)
                    .onSnapshot((snapshot) => {
                        snapshot.docs.forEach((doc, index) => {
                            if (doc.exists) {
                                let appObj = { ...doc.data(), id: doc.id };
                                list.push(appObj);
                            }
                        });
                        const uniqueList = list.filter(
                            (user, index, self) =>
                                index === self.findIndex((u) => u.id === user.id)
                        );

                        uniqueList.sort((a, b) => (a.displayName > b.displayName ? 1 : -1));
                        setUsersFilterList(uniqueList);
                    });
            });

        // const leadsTest = firestore.collection("leads").where("form_name", "==", "Contact Page Contact Form").orderBy("createDate").onSnapshot((snapshot) => {
        //     console.log(snapshot);
        // })

        return () => {
            unsubscribe2();
        };
    }, []);

    useEffect(() => {
        if (!currentUserProfile?.id || !filterUser || !filterStatus) return;

        const canUseLiveSnapshot =
            filterUser === currentUserProfile.id &&
            filterStatus !== "All" &&
            filterEmail === "";

        if (!canUseLiveSnapshot) {
            return;
        }

        const loadStartMs = Date.now();
        const fetchStartMs = Date.now();
        const historyStart =
            historyMonths === "All" ? null : historyMonths === "30days" ? subDays(new Date(), 30) : subMonths(new Date(), parseInt(historyMonths, 10));

        let query = firestore
            .collection("leads")
            .where("userUid", "==", currentUserProfile?.id)
            .where("status", "==", filterStatus)
            .orderBy("assignDate", "asc");

        if (historyStart) {
            query = query.where("assignDate", ">=", historyStart);
        }

        const unsubscribe = query.onSnapshot((snapshot) => {
            const fetchMs = Date.now() - fetchStartMs;
            const processStartMs = Date.now();
            let list = [];
            snapshot.docs.forEach((doc) => {
                if (doc.exists) {
                    let data = doc.data();

                    // Skip archived
                    if (data.status !== "Archived") {
                        // Transform "Prospective" to "Contacted-In Progress"
                        if (data.status === "Prospective") {
                            data.originalStatus = data.status;
                            data.status = "Contacted-In Progress";
                        }

                        let appObj = { ...data, id: doc.id };
                        list.push(appObj);
                    }
                }
            });
            list.sort((a, b) => (a.assignDate < b.assignDate ? 1 : -1));
            setLeads(list);
            const processMs = Date.now() - processStartMs;

            if (!initialLoadLoggedRef.current) {
                initialLoadLoggedRef.current = true;
                let payloadBytes = 0;
                try {
                    payloadBytes = JSON.stringify(list).length;
                } catch (error) {
                    payloadBytes = 0;
                }
                sendPerfLog({
                    action: "leads_list_load",
                    durationMs: Date.now() - loadStartMs,
                    fetchMs,
                    processMs,
                    count: list.length,
                    status: filterStatus,
                    historyMonths,
                    fromCache: snapshot.metadata?.fromCache || false,
                    payloadBytes,
                    userId: currentUserProfile?.id || "",
                    displayName: currentUserProfile?.displayName || "",
                    email: currentUserProfile?.email || "",
                    network: getNetworkInfo(),
                    ts: new Date().toISOString(),
                });
            }
        });

        return () => unsubscribe();
    }, [currentUserProfile, filterUser, filterStatus, filterEmail, historyMonths]);

    let usersList = [
        {
            key: "All",
            text: "All Users",
            value: "All",
        },
        {
            key: "CurrentTravelAgents",
            text: "Current Travel Agents",
            value: "CurrentTravelAgents",
        },
    ];

    if (usersFilterList) {
        Object.keys(usersFilterList).forEach(function (key, index) {
            usersList.push({
                key: usersFilterList[key].id,
                // text: usersFilterList[key].displayName,
                text: usersFilterList[key].isExternal ? `${usersFilterList[key].displayName} (external consultant)` : usersFilterList[key].displayName,
                value: usersFilterList[key].id,
            });
        });
    }

    const leadStatus = [
        { key: "All", text: "All", value: "All" },
        { key: "Assigned", text: "Assigned", value: "Assigned" },
        { key: "Booked", text: "Booked", value: "Booked" },
        { key: "Lost Lead", text: "Lost Lead", value: "Lost Lead" },
        { key: "Quoted", text: "Quoted", value: "Quoted" },
        { key: "Pending", text: "Pending", value: "Pending" },
        { key: "Follow Up", text: "Follow Up", value: "Follow Up" },
        { key: "Duplicate", text: "Duplicate", value: "Duplicate" },
        { key: "Awaiting Rates", text: "Awaiting Rates", value: "Awaiting Rates" },
        { key: "Travel out of date range", text: "Travel out of date range", value: "Travel out of date range" },
        { key: "Prospective", text: "Contacted-In Progress", value: "Prospective" },
        { key: "Cancelled BKG", text: "Cancelled BKG", value: "Cancelled BKG" },
        { key: "Awaiting client feedback", text: "Awaiting client feedback", value: "Awaiting client feedback" },
        { key: "Archived", text: "Archived", value: "Archived" },
    ];

    const updateFilter = useCallback((value) => {
        setFilterValue(value);
    }, []);

    const updateUser = useCallback((value) => {
        setFilterUser(value);
    }, []);
    const updateStatus = useCallback((value) => {
        // setFilterStatus(value);
        dispatch(setFilterStatus(value));
    }, []);

    async function changeConsultant(userUid, status, email, history) {
        const filterStartMs = Date.now();
        let fetchMs = null;
        let processMs = null;
        let fltUser = "";
        let fltStatus = "";
        let fltEmail = "";
        let fltHistory = historyMonths;
        let resultCount = 0;
        let result = null;

        if (userUid !== "" && userUid !== undefined) {
            updateUser(userUid.value);
        }
        if (status !== "" && status !== undefined && filterStatus !== "" && filterStatus !== undefined) {
            // if (status !== "" && status !== undefined) {
            updateStatus(status.value);
        }

        if (email !== "" && email !== undefined) {
            setFilterEmail(email);
        }

        if (history !== "" && history !== undefined) {
            setHistoryMonths(history.value);
            fltHistory = history.value;
        }

        const hasUser = userUid !== "" && userUid !== undefined;
        const hasStatus = status !== "" && status !== undefined;
        const hasEmail = email !== "" && email !== undefined;
        const hasHistory = history !== "" && history !== undefined;

        fltUser = hasUser ? userUid.value : filterUser;
        fltStatus = hasStatus ? status.value : filterStatus;
        fltEmail = hasEmail ? email : filterEmail;
        fltHistory = hasHistory ? history.value : historyMonths;

        setLeads([]);
        setLoadingLeads(true);
        setGlobalFilter("");

        const filterInput = document.getElementById("filterValue");
        let filterValue = filterInput ? filterInput.value : "";

        if (fltUser !== "All" || (fltUser === "All" && fltEmail !== "")) {
            // if(currentUserProfile && currentUserProfile?.noLeadsLoad && currentUserProfile?.noLeadsLoad !== "0"){
            //     var last_date = subMonths(new Date(), currentUserProfile?.noLeadsLoad);
            // }else{
            //     var last_date = new Date("2000-01-01");
            // }

            const fetchStartMs = Date.now();
            let queryUser = fltUser;
            if (fltUser === "CurrentTravelAgents") {
                queryUser = usersFilterList.filter((u) => u.isCurrentAgent === true).map((u) => u.id);
            }
            result = await getAssignedLeads(queryUser, fltStatus, fltEmail, fltHistory);
            fetchMs = Date.now() - fetchStartMs;
            const processStartMs = Date.now();
            const leadsQuery = result?.leads || [];
            leadsQuery.sort((a, b) => (a.assignDate < b.assignDate ? 1 : -1));
            setLeads(leadsQuery);
            resultCount = leadsQuery.length;
            setShowSearchError(false);
            processMs = Date.now() - processStartMs;
        } else {
            setShowSearchError(true);
        }

        setGlobalFilter(filterValue);

        setLoadingLeads(false);
        let payloadBytes = 0;
        try {
            payloadBytes = JSON.stringify(result?.leads || []).length;
        } catch (error) {
            payloadBytes = 0;
        }
        sendPerfLog({
            action: "leads_filter_change",
            durationMs: Date.now() - filterStartMs,
            fetchMs,
            processMs,
            count: resultCount,
            filterUser: fltUser || "",
            filterStatus: fltStatus || "",
            filterEmail: fltEmail || "",
            historyMonths: fltHistory || "",
            fromCache: result?.fromCache ?? null,
            payloadBytes,
            userId: currentUserProfile?.id || "",
            displayName: currentUserProfile?.displayName || "",
            email: currentUserProfile?.email || "",
            network: getNetworkInfo(),
            ts: new Date().toISOString(),
        });
    }

    const data = useMemo(() => (leads ? leads : []), [leads]);

    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
                show: false,
            },
            {
                Header: "Assign Date",
                accessor: "assignDate.seconds",
                Cell: (props) => {
                    let helperDate = addSeconds(new Date(0), props.value);
                    let newDate = format(helperDate, "dd MMM yyyy HH:mm a");
                    return newDate;
                },
            },
            {
                Header: "Pickup Delay",
                accessor: "pickupDelay",
            },
            {
                Header: "Form",
                accessor: "form_name",
            },
            {
                Header: "Email",
                accessor: "client_email", // accessor is the "key" in the data
            },
            {
                Header: "Client Name",
                accessor: "client_name",
            },
            {
                Header: "Consultant",
                accessor: "userDisplayName",
            },
            {
                Header: "Status",
                accessor: "status",
            },
            {
                Header: "Destination",
                accessor: "destination",
            },
            {
                Header: "Package",
                accessor: "package",
            },
        ],
        []
    );

    const globalFilter = useMemo(() => "", []);

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, preGlobalFilteredRows, setGlobalFilter } = useTable(
        { columns, data, globalFilter, initialState: { hiddenColumns: ["id"] } },
        useGlobalFilter
    );

    // async function loadMore(){
    //     setLoadingMore(true)
    //     if(filterStatus !== "All"){
    //         await firestore
    //         .collection("leads")
    //         .where("userUid", "==", filterUser)
    //         .where("status", "==", filterStatus)
    //         .onSnapshot((snapshot) => {
    //             let list = [];

    //             snapshot.docs.forEach((doc) => {
    //                 if (doc.exists) {
    //                     if (doc.data().status !== "Archived") {
    //                         let appObj = { ...doc.data(), id: doc.id };
    //                         list.push(appObj);
    //                     }
    //                 }
    //             });
    //             list.sort((a, b) => (a.assignDate < b.assignDate ? 1 : -1));
    //             setLeads(list);
    //             setLoadingMore(false)
    //             setMoreDisabled(true);
    //         });
    //     }else{
    //         await firestore
    //         .collection("leads")
    //         .where("userUid", "==", filterUser)
    //         .onSnapshot((snapshot) => {
    //             let list = [];

    //             snapshot.docs.forEach((doc) => {
    //                 if (doc.exists) {
    //                     if (doc.data().status !== "Archived") {
    //                         let appObj = { ...doc.data(), id: doc.id };
    //                         list.push(appObj);
    //                     }
    //                 }
    //             });
    //             list.sort((a, b) => (a.assignDate < b.assignDate ? 1 : -1));
    //             setLeads(list);
    //             setLoadingMore(false)
    //             setMoreDisabled(true)
    //         });
    //     }

    // }
    if (!currentUserProfile) {
        return <LoadingComponent />; // or just return null
    }
    return (
        <>
            <Formik
                initialValues={{ filterValue: "", filterStatus: filterStatus }}
                // initialValues={{ filterValue: "", filterStatus: "All" }}
                enableReinitialize="true"
                validate={(values) => { }}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        setSubmitting(false);
                    }, 400);
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                    <form onSubmit={handleSubmit} className="ui form">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <Button
                                        style={{ marginTop: -5, width: "100%" }}
                                        color="orange"
                                        onClick={() => dispatch(openModal({ modalType: "LeadCreateModal", modalProps: { status: "Assigned" } }))}
                                    >
                                        Add Lead
                                    </Button>
                                </Grid.Column>

                                {currentUserProfile && !currentUserProfile?.isExternal && (
                                    <Grid.Column width={3}>
                                        <MySelectInput
                                            label=""
                                            name="filterUser"
                                            options={usersList}
                                            value={filterUser === "" ? (currentUserProfile && currentUserProfile?.id ? currentUserProfile?.id : "") : filterUser}
                                            placeholder="Select a Consultant"
                                            onChange={(field, value) => changeConsultant(value, "", "")}
                                            removeClearable={true}
                                        />
                                    </Grid.Column>
                                )}

                                <Grid.Column width={3}>
                                    <MySelectInput
                                        label=""
                                        name="filterStatus"
                                        options={leadStatus}
                                        value={filterStatus === "" || filterStatus === undefined ? "All" : filterStatus}
                                        // value={filterStatus === "" ? "All" : filterStatus}
                                        placeholder="Select a Status"
                                        onChange={(field, value) => changeConsultant("", value, "")}
                                        removeClearable={true}
                                    />
                                </Grid.Column>

                                <Grid.Column width={3}>
                                    <MySelectInput
                                        label=""
                                        name="historyMonths"
                                        options={historyMonthOptions}
                                        value={historyMonths}
                                        placeholder="History"
                                        onChange={(field, value) => changeConsultant("", "", "", value)}
                                        removeClearable={true}
                                    />
                                </Grid.Column>

                                <Grid.Column width={filterUser === "All" ? 4 : 4}>
                                    <GlobalFilter preGlobalFilteredRows={preGlobalFilteredRows} globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
                                </Grid.Column>
                            </Grid.Row>

                            {filterUser === "All" && (
                                <Grid.Row>
                                    <Grid.Column width={6}>
                                        <MyTextInput label="" name="filterEmail" placeholder="Email" />
                                    </Grid.Column>
                                    <Grid.Column width={2}>
                                        <Button style={{ marginTop: -5 }} color="orange" onClick={() => changeConsultant("", "", values.filterEmail)}>
                                            Search
                                        </Button>
                                    </Grid.Column>
                                </Grid.Row>
                            )}

                            {showSearchError && showSearchError === true && (
                                <Grid.Row>
                                    <Grid.Column textAlign="right" style={{ color: "red" }}>
                                        Please type in an Email address and hit Search when using All users or All status
                                    </Grid.Column>
                                </Grid.Row>
                            )}
                        </Grid>
                    </form>
                )}
            </Formik>
            <br />

            <div>
                Showing {rows.length} of {data.length} Leads
            </div>

            {loadingLeads === true ? (
                <LoadingComponent />
            ) : (
                <>
                    <table {...getTableProps()} className="ui celled table">
                        <thead>
                            {headerGroups.map((headerGroup) => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>{column.render("Header")}</th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map((row) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()} onClick={() => props.history.push("/leads/edit/" + row.values.id)}>
                                        {row.cells.map((cell) => {
                                            return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {/* {currentUserProfile && currentUserProfile?.noLeadsLoad && currentUserProfile?.noLeadsLoad !== "0" && (
                    <Button loading={loadingMore} onClick={() => loadMore()}>Show more</Button>
                )} */}
                </>
            )}
        </>
    );
}
